<template>
    <div class="NoticePub">
        <mediaCenter tabIndex="6"></mediaCenter>
        <div :class="isMobile ? '' : 'industryBox'">
            <div :class="isMobile ? 'industryItem' : 'industryList clearfix'" v-for="item in noticeList" :key="item.id">
                <template v-if="!isMobile">
                    <p class="fl overh2" @click="jumpToDetails(item)">{{item.title}}</p>
                    <span class="fr time">{{formatDate(item.addTime)}}</span>
                </template>
                <template v-else>
                    <p class="overh2" @click="jumpToDetails(item)">{{item.title}}</p>
                    <p class="textr c99 mt5">{{formatDate(item.addTime)}}</p>
                </template>
            </div>
            <div v-if="!loading && noticeList.length === 0">
                <el-empty description="暂无数据"></el-empty>
            </div>
            <el-pagination
                class="pageBox"
                v-if="noticeList.length !== 0"
                background
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :layout="isMobile ? 'prev, pager, next' : 'prev, pager, next, jumper'"
                :pager-count="isMobile ? 5 : 7"
                :total="total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import mediaCenter from '@/components/mediaCenter'
const NEW_API_BASE = process.env.VUE_APP_NEW_API_URL || '/prod-api'
const newApi = (path) => NEW_API_BASE + path

export default {
    name: 'NoticePub',
    components: {
        mediaCenter
    },
    data() {
        return {
            noticeList: [],
            loading: true,
            currentPage: 1,
            total: 0
        }
    },
    mounted() {
        this.getNotice()
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return ''
            return dateStr.split(' ')[0]
        },
        // 获取公众参与公示
        getNotice() {
            this.loading = true
            this.Request({
                url: newApi('/hzfglSys/news/public/newsList'),
                baseURL: '',
                method: 'get',
                data: {
                    pageindex: this.currentPage,
                    pagesize: 10,
                    webcode: 'web_100145',
                    years: 5
                }
            }).then((res) => {
                const data = res.data
                this.noticeList = (data && data.rows) || []
                this.total = (data && data.total) || 0
            }).finally(() => {
                this.loading = false
            })
        },
        jumpToDetails(item) {
            if (item.webUrl) {
                const url = /^https?:\/\//i.test(item.webUrl) ? item.webUrl : 'http://' + item.webUrl
                window.open(url, '_blank')
            } else {
                this.$router.push({ path: '/mediaCenter/NoticePubDetails', query: { id: item.id } })
            }
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getNotice()
        }
    }
}
</script>

<style scoped>
    .industryBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 17px;
    }
    .industryList{
        padding: 32px 0;
        border-bottom: 1px solid #E1E1E1;
    }
    .industryList p{
        max-width: 90%;
        cursor: pointer;
    }
    .industryItem{
        padding: 15px 10px;
        border-bottom: 1px solid #E1E1E1;
    }
    .pageBox{
        text-align: center;
        margin-top: 35px;
        margin-bottom: 42px;
    }
</style>
